<template>
    <div class="va-nav">
        <div class="va-logo">
            <div class="va-logo-img"></div>
            <span class="va-title">VoiceApp</span>
        </div>

        <div class="va-menu-bar" v-if="auth.user.authenticated">
            <router-link :to="{ name: 'users' }" class="va-menu-item" :class="activeClass('users')">
                <i class="el-icon-user"></i> Users
                <div class="va-menu-item-rounded"></div>
            </router-link>

            <router-link :to="{ name: 'tasks' }" class="va-menu-item" :class="activeClass('tasks')">
                <i class="el-icon-chat-line-round"></i> Tasks
                <div class="va-menu-item-rounded"></div>
            </router-link>
        </div>

        <div class="va-nav-user">
            <div class="va-nav-user-logout" @click="signout()" v-if="auth.user.authenticated">
                <el-tooltip content="Logout" placement="bottom" effect="light" :open-delay="1000">
                    <i class="el-icon-switch-button"></i>
                </el-tooltip>
            </div>
            <div class="va-nav-user-text" v-if="auth.user.authenticated">
                <span class="va-nav-user-name">{{ auth.user.profile.firstName }} {{ auth.user.profile.lastName }}</span>
                <span class="va-nav-user-district">{{ auth.user.profile.username }}</span>
            </div>
            <div class="va-nav-user-icon" v-show="auth.user.authenticated"></div>
        </div>
    </div>
</template>

<script>
import auth from '../../auth.js'
import { hashicon } from '@emeraldpay/hashicon'

export default {
    data() {
        return {
            auth: auth
        }
    },

    methods: {
        signout() {
            auth.signout()
        },
        activeClass(pathName) {
            return this.$route.name === pathName ? 'va-menu-icon-active' : ''
        }
    },

    watch: {
        auth: {
            // On change of auth obj, the hashicon gets attached to the navbar
            handler(newAuth, oldAuth) {
                if (newAuth.user.authenticated) {
                    //append hashicon only if user authenticated
                    const params = {
                        // size px (HiDPI/Retina aware)
                        size: 100,

                        // primary color range radius ( 0=red, 60=yellow, 120=green, ..., 360=red )
                        hue: { min: 10, max: 30 },

                        // saturation ( 0=grey, 100=colorfull )
                        saturation: { min: 70, max: 100 },

                        // lightness ( 0=extremlydark, 50=optimal, 100=extremlybright )
                        lightness: { min: 45, max: 65 },

                        // hue variation for individual triangles
                        variation: { min: 7, max: 14, enabled: true },

                        // color shift from primary hue to secondary hue ( the pattern )
                        shift: { min: 20, max: 40 },

                        // the pattern opacity
                        figurealpha: { min: 0.7, max: 1.2 }, // alpha

                        // simulate a 3d cube by different areas gets some more/less light applyed
                        light: { top: 10, right: -8, left: -4, enabled: true }
                    }

                    const icon = hashicon(newAuth.user.profile.username, params) //generate canvas icon for 100px
                    icon.setAttribute('style', 'width: 50px; height: 50px') //scale it down to 50px
                    let el = document.getElementsByClassName('va-nav-user-icon')[0]
                    el.innerHTML = ''
                    el.appendChild(icon)
                }
            },
            deep: true
        }
    }
}
</script>
